import { EditSpeakOptions } from "../EditSpeakOptions";
import { HelpOrtho } from "./HelpOrtho";
import { UsefulOrthoLinks } from "./UsefulOrthoLinks";
import { EnterOrtho } from "./EnterOrtho";
import { ShowIpa } from "./ShowIpa";
import { useState } from "react";
import { ConversionRules } from "./conversionRules";
import { KeyMap, KeyToOrthoMapping } from "./keyToOrthoMapping";
import { RuleSet } from "../../rules/ruleSet";
import { LoadBar } from "./LoadBar";
import { RulesEditor } from "./RulesEditor";
import { speakPhonemes } from "../../speak/speakPhonemes";

/** when an explicit width is needed for content */
const roughWidth = 580;

/** UI for creating a custom orthography that gets converted to IPA */
export function OrthographyArea() {
  const [keys] = useState(new KeyToOrthoMapping());
  const [keysName, setKeysName] = useState('');
  const [orthoSingles, setOrthoSingles] = useState(keys.getSingle());
  const [orthoMultis, setOrthoMultis] = useState(keys.getMulti());
  const [listVersion, setListVersion] = useState(0);
  const [rules] = useState(new ConversionRules());
  const [rulesName, setRulesName] = useState('');
  const [rulesVersion, setRulesVersion] = useState(rules.getVersion());
  const [orthoText, setOrthoText] = useState('');
  const [ipaText, setIpaText] = useState('');
  const [unrecognized, setUnrecognized] = useState('');
  const [phoneLengths, setPhoneLengths] = useState(rules.getAddPhonemeLength());

  function changeOrthoMapping(keystroke: string, symbols: string[]) {
    keys.setAssignment(keystroke, symbols);
    setOrthoSingles(keys.getSingle());
    setOrthoMultis(keys.getMulti());
  }
  function deleteKey(keystroke: string) {
    keys.deleteKey(keystroke);
    setOrthoSingles(keys.getSingle());
    setOrthoMultis(keys.getMulti());
  }
  function moveKey(keystroke: string, where: 'up' | 'down') {
    keys.moveKey(keystroke, where);
    setOrthoSingles(keys.getSingle());
    setOrthoMultis(keys.getMulti());
  }
  function clearOrthMappings() {
    keys.clearAll();
    setOrthoSingles(keys.getSingle());
    setOrthoMultis(keys.getMulti());
  }

  function listChanged() {
    setListVersion(listVersion + 1);
  }

  function changeOrthoText(newText: string) {
    setOrthoText(newText);
    const ipa = rules.convert(newText);
    setIpaText(ipa);
  }

  function rulesChanged() {
    const ipa = rules.convert(orthoText);
    setIpaText(ipa);
    setPhoneLengths(rules.getAddPhonemeLength());
    setRulesVersion(rules.getVersion());
  }

  function onLoadKeys(name: string, newKeys: KeyMap) {
    keys.setAll(newKeys);
    setOrthoSingles(keys.getSingle());
    setOrthoMultis(keys.getMulti());
    setKeysName(name);
  }
  function onLoadRules(name: string, newRules: RuleSet): true | string[] {
    const result = rules.setRuleSet(newRules);
    if (result !== true) {
      return result;  // errors
    }
    rulesChanged();
    setRulesName(name);
    return true;
  }

  function getKeyHelp(k: string) { return rules.getKeyHelp(k); }

  function speakIpa() {
    const { unsupported } = speakPhonemes(ipaText, undefined, phoneLengths);
    setUnrecognized(unsupported === undefined ? '' : unsupported.join(' '));
  }

  return (<>
    <h1>Custom Orthography to IPA</h1>
    <div style={{ display: 'grid', gridTemplateColumns: 'auto 220px' }}>
      <div>
        <HelpOrtho />  <br />
        <LoadBar version={listVersion} width={roughWidth} onLoadKeys={onLoadKeys} onLoadRules={onLoadRules} />
        <hr />
        <EnterOrtho onChangeText={changeOrthoText} setAssignment={changeOrthoMapping} moveKey={moveKey}
          deleteKey={deleteKey} clearAll={clearOrthMappings} keyListChanged={listChanged}
          all={keys.getAll()} single={orthoSingles} multi={orthoMultis} keys={keys.getAll()} width={roughWidth}
          name={keysName} keyNameChanged={setKeysName} getKeyHelp={getKeyHelp} onSpeak={speakIpa} />
        <br /><br />
        <ShowIpa value={ipaText} onChange={setIpaText} speakIpa={speakIpa} width={roughWidth} />
        {unrecognized === '' ? <></> : <><br />unrecognized IPA: {unrecognized}</>}
        <hr />
        <RulesEditor version={rulesVersion} rules={rules} rulesChanged={rulesChanged}
          ruleListChanged={listChanged} name={rulesName} ruleNameChanged={setRulesName}
          single={orthoSingles} multi={orthoMultis} width={roughWidth} />
      </div>

      <div style={{ textAlign: 'left' }}>
        Synthesizer Settings<br /><br />
        <EditSpeakOptions vertical={true} />
        <br /> <hr /> <br />
        <UsefulOrthoLinks />
      </div>
    </div>
  </>);
}
